import React, { useState, useEffect } from 'react'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import templates, { mailSubjects } from './templates'
import './styles/styles.scss'
import ProgramView from './ProgramView'
import { parse, addDays } from 'date-fns'
import pl from 'date-fns/locale/pl'

const highlightText = (text, keywords) => {
    if (!keywords.length) return text

    // Usuwamy słowa, które mają mniej niż 3 znaki
    const validKeywords = keywords.filter((word) => word.length >= 3)
    if (!validKeywords.length) return text // Jeśli nic nie ma, zwracamy oryginał

    // Tworzymy REGEX tylko dla poprawnych fraz
    const regex = new RegExp(`(${validKeywords.join('|')})`, 'gi')

    return text.split(regex).map((part, index) =>
        validKeywords.includes(part.toLowerCase()) ? ( // Sprawdzamy, czy część pasuje do listy
            <mark key={index}>{part}</mark>
        ) : (
            part
        )
    )
}

const commandReplacements = {
    ">update": "15 maja 2026",
}

const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)]

const generateMainMailTo = (tytul, link_glowny, opcja) => {
    const subjects = [
        `Praktyczna wiedza w działaniu – ${tytul}`,
        `Ekspert dzieli się doświadczeniem – ${tytul}`,
        `Skuteczne metody w praktyce – ${tytul}`,
        `Sprawdzone rozwiązania krok po kroku – ${tytul}`,
        `Cenne wskazówki od praktyka – ${tytul}`,
        `Jak robią to najlepsi? – ${tytul}`,
        `Najlepsze praktyki w Twojej branży – ${tytul}`,
        `Doświadczenie, które działa – ${tytul}`,
        `Konkrety, które możesz zastosować – ${tytul}`,
        `Tego nie uczą w teorii – ${tytul}`,
        `Praktyczne podejście do tematu – ${tytul}`,
        `To działa – sprawdzone w praktyce – ${tytul}`,
        `Zastosuj to w swojej pracy – ${tytul}`,
        `Wiedza, którą możesz wykorzystać od razu – ${tytul}`,
        `Ekspert wyjaśnia, jak to robić dobrze – ${tytul}`,
        `Skuteczne rozwiązania w Twoich rękach – ${tytul}`,
        `Najważniejsze aspekty w praktycznym ujęciu – ${tytul}`,
        `Sprawdzone sposoby na lepsze efekty – ${tytul}`,
        `Krok po kroku do skutecznych rozwiązań – ${tytul}`,
        `Bez zbędnej teorii – konkretne rozwiązania – ${tytul}`,
    ]

    const subject = subjects[Math.floor(Math.random() * subjects.length)]

    return `mailto:?subject=${encodeURIComponent(subject)}`
}

const generateBasketMailTo = () => {
    const subject = getRandomElement(mailSubjects) // 🔥 Losujemy temat

    window.open(`mailto:?subject=${encodeURIComponent(subject)}`)
}

const copyBasketContent = (opcja, basket, setAlertVisible, imie) => {
    if (basket.length === 0) return

    let powitanie = getRandomElement(templates[opcja].powitanie)
    let klauzula = getRandomElement(templates[opcja].klauzula)
    let dodatkowePytanie = getRandomElement(templates[opcja].dodatkowePytania)

    if (imie.trim() !== '') {
        powitanie = powitanie.replace('{IMIĘ}', imie)
    } else {
        powitanie = getRandomElement(templates[opcja].bezImienia)
    }

    // 🔥 Śledzimy już użyte frazy "nastepneSzkolenie"
    let usedVariants = new Set()

    let tresc = basket
        .map((item, index) => {
            let cleanTitle = item.tytul.split(/[.?]/)[0].trim()
            let link = item.link

            let wiadomosc = getRandomElement(templates[opcja].wiadomosc)(
                cleanTitle,
                link,
                item.termin
            )

            if (index > 0) {
                // 🔄 Filtrujemy nieużyte warianty
                let availableVariants = templates[
                    opcja
                ].nastepneSzkolenie.filter(
                    (variant) => !usedVariants.has(variant)
                )

                let nastepneSzkolenie
                if (availableVariants.length > 0) {
                    nastepneSzkolenie = getRandomElement(availableVariants)
                    usedVariants.add(nastepneSzkolenie) // ✅ Dodajemy do użytych
                } else {
                    nastepneSzkolenie = getRandomElement(
                        templates[opcja].nastepneSzkolenie
                    ) // Jeśli wszystkie były użyte, losujemy dowolny
                }

                return `\n${nastepneSzkolenie(cleanTitle, link, item.termin)}`
            }

            return wiadomosc
        })
        .join('\n\n')

    const text = `${powitanie}\n\n\n${tresc}\n\n\n${dodatkowePytanie}\n\n\n${klauzula}\n\n`

    navigator.clipboard.writeText(text).then(() => {
        setAlertVisible(true)
        setTimeout(() => setAlertVisible(false), 2000)
    })
}

function filterByDate(szkolenia, dateFrom, dateTo, setFiltered) {
    // dateFrom i dateTo są w formacie "YYYY-MM-DD"
    const from = dateFrom ? new Date(dateFrom) : addDays(new Date(), 7)
    const to = dateTo ? new Date(dateTo) : addDays(new Date(), 14)
    from.setHours(0, 0, 0, 0)
    to.setHours(0, 0, 0, 0)

    const wynik = szkolenia.filter((szkolenie) =>
        szkolenie.terminy.some(({ data }) => {
            const d = parse(data, 'dd MMMM yyyy', new Date(), { locale: pl })
            d.setHours(0, 0, 0, 0)

            // UWAGA! <= od/do, żeby data graniczna była zawarta:
            return d >= from && d <= to
        })
    )

    setFiltered(wynik)
}

const App = () => {
    const [query, setQuery] = useState('')
    const [szkolenia, setSzkolenia] = useState([])
    const [filtered, setFiltered] = useState([])
    const [alertVisible, setAlertVisible] = useState(false)
    const [imie, setImie] = useState('')
    const [selectedProgram, setSelectedProgram] = useState(null)

    const [title, setTitle] = useState('COURSEEKER')
    const [programSearch, setProgramSearch] = useState('')
    const [, setClickCount] = useState(0)
    const [basket, setBasket] = useState([]) // Koszyk zapisanych szkoleń
    const [expandedTitles, setExpandedTitles] = useState({})
    const [isCRSKR, setIsCRSKR] = useState(false) // ✅ Nowy stan do przełączania tytułu

    const [showDateFilter, setShowDateFilter] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [showDateResults, setShowDateResults] = useState(false)
    const [dateFiltered, setDateFiltered] = useState([])

    // ▼▼▼ DODAJ PONIŻEJ ▼▼▼
    const [clientQuery, setClientQuery] = useState('')
    const [clientResults, setClientResults] = useState([]) // { szkolenie, snippets: [] }
    const [programsIndex, setProgramsIndex] = useState(new Map()) // key: programPath, value: text
    const [isIndexBuilt, setIsIndexBuilt] = useState(false)
    const [isClientLoading, setIsClientLoading] = useState(false)
    // ▼ NOWE
    const [clientMode, setClientMode] = useState(false) // przełącznik trybu
    const [clientTimer, setClientTimer] = useState(null) // debounce

    useEffect(() => {
        if (!clientMode) return
        if (clientTimer) clearTimeout(clientTimer)
        const t = setTimeout(() => runClientSearch(), 300)
        setClientTimer(t)
        return () => clearTimeout(t)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientQuery, clientMode, programsIndex])

    // 🔍 Funkcja do sprawdzania, czy użytkownik przewinął w dół
    const checkScrollTop = () => {
        const btn = document.getElementById('scrollTopBtn')
        if (btn) {
            if (window.scrollY > 300) {
                btn.classList.add('show')
            } else {
                btn.classList.remove('show')
            }
        }
    }

    useEffect(() => {
        if (showDateFilter) {
            const today = new Date()
            const from = new Date(today)
            from.setDate(today.getDate() + 7)
            const to = new Date(today)
            to.setDate(today.getDate() + 12)

            setDateFrom(from.toISOString().slice(0, 10))
            setDateTo(to.toISOString().slice(0, 10))
        }
    }, [showDateFilter])

    // ▼▼▼ DODAJ PONIŻEJ ▼▼▼
    const normalize = (s) => s.normalize('NFKC').toLowerCase()

    const parseClientGroups = (raw) => {
        // Zwraca tablicę grup, każda grupa = tablica tokenów z '+'
        // Przykład: "rejestr+grunt;ewidencja" => [ ["rejestr","grunt"], ["ewidencja"] ]
        const groupsRaw = raw
            .split(';')
            .map((g) => g.trim())
            .filter(Boolean)

        // Zachowujemy Twoje minima długości na poziomie CAŁEJ grupy (zgodnie z dotychczasową logiką):
        const filteredGroups = groupsRaw.filter((g, i) =>
            i === 0 ? g.length >= 2 : g.length >= 3
        )

        return filteredGroups.map((g) =>
            g
                .split('+')
                .map((t) => normalize(t.trim()))
                .filter(Boolean)
        )
    }

    const replaceCommands = (text) => {
        return commandReplacements[text] || text
    }

    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop)
        return () => {
            window.removeEventListener('scroll', checkScrollTop)
        }
    }, [])

    // ⏬ Przewinięcie do góry
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleTitleClick = () => {
        setClickCount((prev) => {
            if (prev + 1 === 3) {
                setTitle(isCRSKR ? 'COURSEEKER' : 'CRSKR') // ✅ Przełączanie tytułu
                setIsCRSKR(!isCRSKR) // ✅ Zmiana stanu
                return 0 // Reset licznika
            }
            return prev + 1
        })

        // Opcjonalnie: Reset licznika po 1 sekundzie, jeśli użytkownik nie klika dalej
        setTimeout(() => {
            setClickCount(0)
        }, 1000)
    }

    const toggleTitle = (id) => {
        setExpandedTitles((prev) => ({
            ...prev,
            [id]: !prev[id], // Przełączamy stan rozwinięcia
        }))
    }

    const toggleBasketItem = (szkolenie, termin) => {
        const id = `${szkolenie.tytul}-${termin.data}`

        setBasket((prevBasket) => {
            if (prevBasket.some((item) => item.id === id)) {
                return prevBasket.filter((item) => item.id !== id)
            } else {
                return [
                    ...prevBasket,
                    {
                        id,
                        tytul: szkolenie.tytul,
                        termin: termin.data,
                        link: szkolenie.link_glowny, // ✅ Pobieramy link ze szkolenia
                    },
                ]
            }
        })
    }

    const formatImie = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    }

    useEffect(() => {
        fetch('/dates.json')
            .then((res) => res.json())
            .then((data) => setSzkolenia(data.szkolenia))
            .catch((err) => console.error('Błąd ładowania JSON:', err))
    }, [])
    // ▼▼▼ DODAJ PONIŻEJ ▼▼▼
    const programPathFor = (szkolenie) =>
        `/programy/${(szkolenie.link_glowny || '').split('/').pop()}.md`

    const buildProgramsIndex = async () => {
        if (!szkolenia?.length || isIndexBuilt) return
        setIsClientLoading(true)
        try {
            const entries = await Promise.all(
                szkolenia.map(async (s) => {
                    const path = programPathFor(s)
                    try {
                        const res = await fetch(path)
                        if (!res.ok) return [path, '']
                        const text = await res.text()
                        return [path, text]
                    } catch {
                        return [path, '']
                    }
                })
            )
            const map = new Map(entries)
            setProgramsIndex(map)
            setIsIndexBuilt(true)
        } finally {
            setIsClientLoading(false)
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            let keywords = query
                .toLowerCase()
                .split(';')
                .map((word) => word.trim())
                .filter((word) => word.length > 0) // Usuwamy puste ciągi

            if (keywords.length === 0 || keywords[0].length < 2) {
                setFiltered([])
                return
            }

            if (keywords.length > 1) {
                keywords = keywords.filter(
                    (word, index) => index === 0 || word.length >= 3
                )
            }

            const newFiltered = szkolenia.filter((szkolenie) =>
                keywords.every((keyword) =>
                    szkolenie.tytul.toLowerCase().includes(keyword)
                )
            )

            setFiltered(newFiltered)
        }, 300) // Opóźnienie 300ms, żeby Espanso nie powodowało zapętlenia

        return () => clearTimeout(handler) // Usuwamy timeout, jeśli query się zmieni szybko
    }, [query, szkolenia])


    const copyMainLinkToClipboard = (tytul, link_glowny, opcja, terminy) => {
        const cleanTitle = tytul.split(/[.?]/)[0].trim()

        // 🔍 Wybieramy najbliższy termin
        let najblizszyTermin = 'Termin do ustalenia'
        if (terminy.length > 0) {
            const sortedDates = terminy
                .map((t) => t.data)
                .filter(Boolean) // Usuwa wartości null/undefined
                .sort((a, b) => parse(a, 'dd MMMM yyyy', new Date(), { locale: pl }) - parse(b, 'dd MMMM yyyy', new Date(), { locale: pl })) // Sortuje po dacie
            najblizszyTermin = sortedDates[0] || 'Termin do ustalenia'
        }

        let powitanie = getRandomElement(templates[opcja].powitanie)
        let klauzula = getRandomElement(templates[opcja].klauzula)
        let dodatkowePytanie = getRandomElement(
            templates[opcja].dodatkowePytania
        ) // ✅ Losujemy pytanie

        let wiadomosc = getRandomElement(templates[opcja].wiadomosc)(
            cleanTitle,
            link_glowny,
            najblizszyTermin // ✅ Przekazujemy najbliższą datę
        )

        if (imie.trim() !== '') {
            powitanie = getRandomElement(templates[opcja].powitanie).replace(
                '{IMIĘ}',
                imie
            )
        } else {
            powitanie = getRandomElement(templates[opcja].bezImienia)
        }

        const text = `${powitanie}\n\n\n${wiadomosc}\n\n\n${dodatkowePytanie}\n\n\n${klauzula}\n\n`

        navigator.clipboard.writeText(text).then(() => {
            setAlertVisible(true)
            setTimeout(() => setAlertVisible(false), 2000)
        })
    }
    const buildLines = (title, programText) => {
        const lines = []
        if (title) lines.push(title)
        if (programText) lines.push(...programText.split(/\r?\n/))
        return lines
    }

    const anyLineContainsAll = (lines, tokens) => {
        return lines.some((line) => {
            const low = normalize(line)
            return tokens.every((tok) => low.includes(tok))
        })
    }

    // groups = [ ["zewa","fizy"], ["ewidencja"] ] itd.
    // Każda grupa MUSI być spełniona w JEDNEJ linii (dla tej grupy),
    // a grupy są połączone AND-em w skali całego dokumentu.
    const matchesGroups = (title, programText, groups) => {
        const lines = buildLines(title, programText)
        return groups.every((tokens) => anyLineContainsAll(lines, tokens))
    }

    const escapeReg = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    // 🔢 Liczenie wszystkich wystąpień wszystkich tokenów w tytule + programie
    const countTokenOccurrences = (title, programText, tokens) => {
        const text = normalize(`${title}\n${programText || ''}`)
        return tokens.reduce((sum, tok) => {
            if (!tok) return sum
            const re = new RegExp(escapeReg(tok), 'g')
            const matches = text.match(re)
            return sum + (matches ? matches.length : 0)
        }, 0)
    }

    // Zwróć maksymalnie `maxSnippets` linii spełniających kolejne grupy.
    // Każda linia ma <mark> wokół trafień (wszystkich tokenów z danej grupy).
    const buildSnippets = (title, programText, groups, maxSnippets = 3) => {
        const lines = buildLines(title, programText)
        const out = []

        for (const tokens of groups) {
            const line = lines.find((ln) => {
                const low = normalize(ln)
                return tokens.every((t) => low.includes(t))
            })
            if (line) {
                let html = line
                // podświetl WSZYSTKIE tokeny tej grupy
                tokens.forEach((t) => {
                    const re = new RegExp(`(${escapeReg(t)})`, 'gi')
                    html = html.replace(re, '<mark>$1</mark>')
                })
                out.push(html)
            }
            if (out.length >= maxSnippets) break
        }

        return out
    }

    const runClientSearch = () => {
        const groups = parseClientGroups(clientQuery)
        if (!groups.length) {
            setClientResults([])
            return
        }

        // 🔡 Wszystkie frazy z zapytania (spłaszczone, bez duplikatów)
        const allTokens = Array.from(new Set(groups.flat().filter(Boolean)))

        const results = szkolenia
            .map((s) => {
                const title = s.tytul || ''
                const path = programPathFor(s)
                const programText = programsIndex.get(path) || ''

                if (matchesGroups(title, programText, groups)) {
                    const hitCount = countTokenOccurrences(
                        title,
                        programText,
                        allTokens
                    )

                    return {
                        szkolenie: s,
                        snippets: buildSnippets(title, programText, groups),
                        hitCount,
                    }
                }
                return null
            })
            .filter(Boolean)
            // 🔽 sortowanie: najwięcej trafień na górze
            .sort((a, b) => b.hitCount - a.hitCount)

        setClientResults(results)
    }
    const renderSzkolenieListItem = (
        szkolenie,
        index,
        {
            highlightFromQuery = true,
            badgesAfterTitle = null,
            extraUnderTitle = null,
            programSearchText = query,
        } = {}
    ) => {
        const terminy = szkolenie.terminy || []

        return (
            <tr key={index}>
                <td className="cell-main">
                    <div className="course-title">
                        {highlightFromQuery
                            ? highlightText(szkolenie.tytul, query.split(';'))
                            : szkolenie.tytul}
                        {badgesAfterTitle}
                    </div>

                    {extraUnderTitle}

                    <div className="dates-row">
                        {terminy.map((termin, tIndex) => {
                            const isChecked = basket.some(
                                (item) =>
                                    item.id ===
                                    `${szkolenie.tytul}-${termin.data}`
                            )
                            return (
                                <span
                                    key={tIndex}
                                    className={`date-tag${isChecked ? ' checked' : ''}`}
                                    onClick={() =>
                                        toggleBasketItem(szkolenie, termin)
                                    }
                                >
                                    <span className="date-checkbox"></span>
                                    {termin.data}
                                </span>
                            )
                        })}
                    </div>
                </td>

                <td className="cell-actions">
                    <div className="action-buttons">
                        <div className="dropdown">
                            <button
                                className="action-btn"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                title="Kopiuj treść maila"
                            >
                                📜
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() =>
                                            copyMainLinkToClipboard(
                                                szkolenie.tytul,
                                                szkolenie.link_glowny,
                                                'pan',
                                                szkolenie.terminy
                                            )
                                        }
                                    >
                                        👨 Pan
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() =>
                                            copyMainLinkToClipboard(
                                                szkolenie.tytul,
                                                szkolenie.link_glowny,
                                                'pani',
                                                szkolenie.terminy
                                            )
                                        }
                                    >
                                        👩 Pani
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() =>
                                            copyMainLinkToClipboard(
                                                szkolenie.tytul,
                                                szkolenie.link_glowny,
                                                'panstwo',
                                                szkolenie.terminy
                                            )
                                        }
                                    >
                                        👥 Państwo
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <button
                            className="action-btn"
                            title="Otwórz klienta mail"
                            onClick={() =>
                                window.open(
                                    generateMainMailTo(
                                        szkolenie.tytul,
                                        szkolenie.link_glowny,
                                        'pan'
                                    ),
                                    '_blank'
                                )
                            }
                        >
                            ✉️
                        </button>

                        <button
                            className="action-btn"
                            title="Program szkolenia"
                            onClick={() => {
                                setProgramSearch(programSearchText)
                                setSelectedProgram(
                                    `/programy/${szkolenie.link_glowny
                                        .split('/')
                                        .pop()}.md`
                                )
                            }}
                        >
                            📄
                        </button>

                        <a
                            href={szkolenie.link_glowny}
                            className="action-btn"
                            title="Link do szkolenia"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            🔗
                        </a>
                    </div>
                </td>
            </tr>
        )
    }

    return (
        <div className="container-fluid mt-4">
            <button
                className="btn btn-primary position-fixed shadow-sm kwadratFiltrowania"
                onClick={() => setShowDateFilter(!showDateFilter)}
            >
                📅
            </button>
            <button
                className="btn btn-success position-fixed shadow-sm kwadratSzukajki"
                style={{ right: '0px' }} // przesunięcie aby nie nachodził na pierwszy
                onClick={async () => {
                    const next = !clientMode
                    setClientMode(next)
                    if (next && !isIndexBuilt) await buildProgramsIndex()
                }}
            >
                🧲
            </button>

            {showDateFilter && (
                <div
                    className="position-absolute bg-dark p-3 border shadow oknoFiltrowania row"
                    style={{ zIndex: 1000 }}
                >
                    <div className="col">
                        <label className="text-uppercase">
                            🟢 Start
                            <input
                                type="date"
                                className="form-control mb-2"
                                value={dateFrom}
                                onChange={(e) => setDateFrom(e.target.value)}
                            />
                        </label>
                    </div>
                    <div className="col">
                        <label className="text-uppercase">
                            🔴 Stop
                            <input
                                type="date"
                                className="form-control mb-3"
                                value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)}
                            />
                        </label>
                    </div>
                    <div className="col d-flex justify-content-center align-items-center">
                        <button
                            className="btn btn-primary btn-md"
                            onClick={() => {
                                filterByDate(
                                    szkolenia,
                                    dateFrom,
                                    dateTo,
                                    setDateFiltered
                                )
                                setShowDateResults(true)
                            }}
                        >
                            Filtruj
                        </button>
                    </div>
                </div>
            )}

            <h1
                className="text-center mb-4 user-select-none d-flex align-items-center justify-content-center gap-2"
                onClick={handleTitleClick}
            >
                <img
                    src="/g15.svg"
                    alt="Wyszukiwarka"
                    className="img-fluid ikonka"
                />
                {title}
                <span
                    className="badge bg-primary"
                    style={{ cursor: 'pointer' }}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#basketOffcanvas"
                >
                    {basket.length}
                </span>
            </h1>

            <div className="mb-3 row">
                <div className="col-md-8">
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Wpisz słowa kluczowe (min. 4 znaki) oddzielone średnikiem (;)..."
                        value={query}
                        onChange={(e) =>
                            setQuery(replaceCommands(e.target.value))
                        }
                    />
                </div>
                <div className="col-md-4 mt-3 mt-sm-0">
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Michale, Magdaleno itd. - Podaj imię (opcjonalnie)"
                        value={imie}
                        onChange={(e) => setImie(formatImie(e.target.value))} // 🔥 Normalizacja imienia
                    />
                </div>
            </div>

            {alertVisible && (
                <div
                    className="alert alert-success text-center fixed-top"
                    role="alert"
                >
                    Treść maila została skopiowana!
                </div>
            )}

            {showDateResults && dateFiltered.length > 0 && (
                <div
                    className="position-fixed top-0 end-0 bg-dark border shadow p-3 m-3 rounded wynikFiltrowania"
                    // style={{ zIndex: 2000, maxWidth: '60vw' }}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="m-0">Wyniki filtrowania</h5>
                        <button
                            className="btn-close"
                            onClick={() => setShowDateResults(false)}
                            aria-label="Zamknij"
                        />
                    </div>
                    <ul
                        className="list-group small"
                        style={{
                            maxHeight: '80vh', // wysokość okna przewijania
                            overflowY: 'auto',
                        }}
                    >
                        {dateFiltered
                            .map((szkolenie, index) => {
                                const terminy = szkolenie.terminy || []
                                const daty = terminy
                                    .map((t) =>
                                        parse(
                                            t.data,
                                            'dd MMMM yyyy',
                                            new Date(),
                                            { locale: pl }
                                        )
                                    )
                                    .filter((d) => !isNaN(d))
                                const najblizsza =
                                    daty.length > 0
                                        ? daty.sort((a, b) => a - b)[0]
                                        : null
                                return {
                                    szkolenie,
                                    najblizsza,
                                }
                            })
                            .sort((a, b) => {
                                if (!a.najblizsza) return 1
                                if (!b.najblizsza) return -1
                                return a.najblizsza - b.najblizsza
                            })
                            .map(({ szkolenie, najblizsza }, index) => (
                                <li key={index} className="list-group-item">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong>{szkolenie.tytul}</strong>
                                            <br />
                                            <button
                                                className="btn btn-outline-info btn-sm me-2"
                                                onClick={() => {
                                                    setShowDateResults(false)
                                                    setSelectedProgram(
                                                        `/programy/${szkolenie.link_glowny
                                                            .split('/')
                                                            .pop()}.md`
                                                    )
                                                }}
                                            >
                                                ZOBACZ
                                            </button>
                                            📅{' '}
                                            {najblizsza
                                                ? najblizsza.toLocaleDateString(
                                                      'pl-PL',
                                                      {
                                                          weekday: 'long',
                                                          day: '2-digit',
                                                          month: 'long',
                                                          year: 'numeric',
                                                      }
                                                  )
                                                : 'brak daty'}
                                        </div>
                                    </div>
                                </li>
                            ))}
                    </ul>
                </div>
            )}
            {clientMode ? (
                /* ▼ Tryb: Klient szuka (druga wyszukiwarka na głównej) */
                <div className="card border-0 bg-transparent mb-4">
                    <div className="card-body p-0">
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="frazy z + jako spację; grupy AND rozdzielone ; (np. rejestr+grunt;ewidencja)"
                                value={clientQuery}
                                onChange={(e) => setClientQuery(e.target.value)}
                            />
                            <div className="form-text">
                                Dopasowania po części wyrazu (np.{' '}
                                <code>rejestr</code> ⇒ też
                                <code> rejestru</code>, <code> rejestrem</code>,{' '}
                                <code> rejestrów</code>).
                            </div>
                        </div>

                        {!isIndexBuilt && isClientLoading && (
                            <p className="text-muted">Ładuję programy…</p>
                        )}

                        {isIndexBuilt && clientQuery.trim().length < 2 && (
                            <p className="text-muted">
                                Wpisz zapytanie (min 2 znaki w pierwszej
                                grupie).
                            </p>
                        )}

                        {isIndexBuilt &&
                            clientQuery.trim().length >= 2 &&
                            clientResults.length === 0 && (
                                <p className="text-muted">Brak wyników.</p>
                            )}

                        {clientResults.length > 0 && (
                            <table className="results-table">
                                <thead>
                                    <tr>
                                        <th>Szkolenie / Terminy</th>
                                        <th>Akcje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {clientResults.map(
                                    (
                                        { szkolenie, snippets, hitCount },
                                        idx
                                    ) => {
                                        const badgesAfterTitle =
                                            typeof hitCount === 'number' ? (
                                                <span
                                                    className="badge bg-secondary ms-2"
                                                    title="Łączna liczba trafień słów kluczowych w tytule i programie"
                                                >
                                                    🎯 {hitCount}
                                                </span>
                                            ) : null

                                        const extraUnderTitle = (
                                            <div className="mt-2 small">
                                                {(snippets.length
                                                    ? snippets
                                                    : [
                                                          'Brak fragmentu – dopasowanie w tytule.',
                                                      ]
                                                ).map((s, i) => (
                                                    <div
                                                        key={i}
                                                        className="text-muted"
                                                        dangerouslySetInnerHTML={{
                                                            __html: s,
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        )

                                        return renderSzkolenieListItem(
                                            szkolenie,
                                            idx,
                                            {
                                                highlightFromQuery: false, // tutaj nie podświetlamy tytułu po `query`
                                                badgesAfterTitle, // 🎯 badge z liczbą trafień
                                                extraUnderTitle, // snippety pod tytułem
                                                programSearchText: clientQuery, // do ProgramView leci fraza z „Klient szuka"
                                            }
                                        )
                                    }
                                )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            ) : (
                /* ▼ Tryb: klasyczna wyszukiwarka (oryginalny blok) */
                <>
                    {query.length < 3 ? (
                        <p className="text-center text-muted">
                            Wpisz przynajmniej 3 znaki, aby rozpocząć
                            wyszukiwanie.
                        </p>
                    ) : filtered.length > 0 ? (
                        <table className="results-table">
                            <thead>
                                <tr>
                                    <th>Szkolenie / Terminy</th>
                                    <th>Akcje</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((szkolenie, index) =>
                                    renderSzkolenieListItem(szkolenie, index)
                                )}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center text-muted">Brak wyników.</p>
                    )}
                </>
            )}
            {selectedProgram && (
                <ProgramView
                    filePath={selectedProgram}
                    initialSearch={programSearch} // 👈 tu wpadają frazy
                    onClose={() => setSelectedProgram(null)}
                />
            )}

            {selectedProgram && !showDateResults && (
                <button
                    className="position-fixed top-0 end-0 m-4 btn btn-light shadow border"
                    style={{
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        zIndex: 3000,
                    }}
                    onClick={() => setShowDateResults(true)}
                    title="Pokaż wyniki filtrowania"
                >
                    📅
                </button>
            )}

            <div
                className="offcanvas offcanvas-end user-select-none"
                tabIndex="-1"
                id="basketOffcanvas"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title mx-auto">
                        📅 Wybrane szkolenia
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                    ></button>
                </div>

                <div className="offcanvas-body d-flex flex-column">
                    {basket.length === 0 ? (
                        <p className="text-muted">
                            Nie masz jeszcze zapisanych szkoleń.
                        </p>
                    ) : (
                        <>
                            <ul className="list-group">
                                {basket.map((item, index) => {
                                    const cleanTitle = item.tytul
                                        .split(/[.?]/)[0]
                                        .trim() // Obcięty tytuł
                                    const isExpanded = expandedTitles[item.id] // Czy rozwinięte?

                                    return (
                                        <li
                                            key={index}
                                            className="list-group-item d-flex justify-content-between align-items-center user-select-all"
                                        >
                                            <span
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                }}
                                                onClick={() =>
                                                    toggleTitle(item.id)
                                                }
                                                title="Kliknij, aby rozwinąć/ukryć tytuł"
                                            >
                                                {isExpanded
                                                    ? item.tytul
                                                    : cleanTitle}{' '}
                                                {/* 🔥 Przełączanie widoku */}
                                            </span>

                                            <button
                                                className="btn btn-sm btn-dark border-danger"
                                                onClick={() =>
                                                    toggleBasketItem(
                                                        { tytul: item.tytul },
                                                        { data: item.termin }
                                                    )
                                                }
                                            >
                                                ❌
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>

                            {/* 🔥 Przycisk do kopiowania treści */}
                            <div className="dropdown mt-4">
                                <button
                                    className="btn btn-primary dropdown-toggle w-100"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    📜 Treść
                                </button>
                                <ul className="dropdown-menu w-100 text-center">
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() =>
                                                copyBasketContent(
                                                    'pan',
                                                    basket,
                                                    setAlertVisible,
                                                    imie
                                                )
                                            }
                                        >
                                            👨 Pan
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() =>
                                                copyBasketContent(
                                                    'pani',
                                                    basket,
                                                    setAlertVisible,
                                                    imie
                                                )
                                            }
                                        >
                                            👩 Pani
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() =>
                                                copyBasketContent(
                                                    'panstwo',
                                                    basket,
                                                    setAlertVisible,
                                                    imie
                                                )
                                            }
                                        >
                                            👥 Państwo
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <button
                                className="btn btn-success btn-sm w-100 mt-2"
                                onClick={() =>
                                    generateBasketMailTo('pan', basket)
                                }
                            >
                                ✉️ Mail
                            </button>
                        </>
                    )}
                </div>
            </div>
            <button id="scrollTopBtn" onClick={scrollToTop}>
                <img src="/scroll-top.svg" alt="Do góry" />
            </button>
        </div>
    )
}

export default App
